import { render } from "./EmpresaEstatistica.vue?vue&type=template&id=26edafdc&scoped=true"
import script from "./EmpresaEstatistica.vue?vue&type=script&lang=js"
export * from "./EmpresaEstatistica.vue?vue&type=script&lang=js"

import "./EmpresaEstatistica.vue?vue&type=style&index=0&id=26edafdc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26edafdc"]])

export default __exports__